<template>
  <div class="wrapper">
    <div id="preloader" v-if="!loaded">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="header">
        <div class="logo">
          <img src="@/assets/images/logo-lg.svg" 
          width="86px"
            height="16px"
          alt="-visipoint-logo" />
        </div>
        <div v-if="registredByEmail" class="header-msgs">
          <p class="main-title">{{$t('common.passportAcc').toUpperCase()}}</p>
          <p class="sub-title">{{ $t('common.oneTimeLogin')}}</p>
        </div>
        <!-- phone -->
        <div v-if="!registredByEmail" class="header-msgs">
          <p class="phone-main-title">One Time Login</p>
          <p class="phone-sub-title">Verify your phone number</p>
          <p class="six-digits-msg">We sent you an SMS with a 6 digit code.</p>
          <p v-if="invalidCode" class="invaled-code-msg">Invalid code</p>
        </div>
      </div>
      <div class="main-content2">
        <div v-if="registredByEmail" class="card2-email">
          <img
            class="mail-icon"
            src="@/assets/images/check-email.svg"
            alt="mail-icon"
          />
          <p class="card-title">{{ $t('common.checkEmail')}}</p>
          <p class="card-msg">
            {{ $t('common.loginEmail')}}
          </p>
        </div>
        <!-- phone -->
        <div v-if="!registredByEmail" class="card">
          <p class="phone-card-title">Code sent to</p>
          <p class="phone-number">+ {{ visitor.username }}</p>
          <div class="verification-code-wrapper">
            <CodeInput
              className="verification-code"
              :class="invalidCode ? 'invalid-code' : ''"
              v-on:change="onChange"
              v-on:complete="onComplete"
              @input="handleInput"
              :fields="6"
            />
          </div>
          <p v-if="verifyCounter > 0" class="counter">
            00:{{ verifyCounter >= 10 ? verifyCounter : `0${verifyCounter}` }}
          </p>

          <button
            @click="resetCount"
            type="button"
            class="resend-btn"
            :disabled="verifyCounter > 0"
          >
            Resend
          </button>
        </div>
        <b-button
          v-if="!registredByEmail"
          variant="primary"
          :disabled="disableSubmit || invalidCode"
          class="main-btn activ-btn"
          :class="disableSubmit || invalidCode ? 'dimmed-btn' : ''"
          @click="handelVerify"
        >
          <span>Verify</span>
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CodeInput from "vue-verification-code-input";
import store from "@/state/store";

export default {
  page: {
    title: "login one time",
  },
  name: "loginOneTime",
  components: { CodeInput },
  data() {
    return {
      timedOut: false,
      loaded: false,
      disableSubmit: true,
      verifyCounter: 60,
      visitor: {
        username: this.$route.query.email || this.$route.query.phone,
        visit_date: this.$route.query.visit_date,
        visit_time: this.$route.query.visit_time,
        entity_id: this.$route.query.entity_id,
        user_type_id: this.$route.query.user_type_id,
        area_id: this.$route.query.area_id,
        registration_method: this.$route.query.registration_method,
        journey_flow_id: this.$route.query.journey_flow_id,
        redirect_url: this.$route.query.redirect_url,
      },
      registredByEmail: this.$route.query.email ? true : false,
      num_1: null,
      num_2: null,
      num_3: null,
      num_4: null,
      num_5: null,
      num_6: null,
      counter_reload: 0,
      invalidCode: false,
    };
  },
  computed: {
    getSixDigits() {
      const { num_1, num_2, num_3, num_4, num_5, num_6 } = this;
      return num_1 + num_2 + num_3 + num_4 + num_5 + num_6;
    },
    // disableSubmitBtn() {
    //   if (this.getSixDigits.length == 6) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
    ...mapGetters("authfack", ["getOneTimeCodeSent"]),
  },
  methods: {
    ...mapActions("authfack", [
      "verifyOneTimeCode",
      "sendVisitortoGetOneTimeCode",
    ]),
    checkSeconds(props) {
      if (props.seconds > 0) this.timedOut = false;
      else this.timedOut = true;
      return props.seconds > 0 ? true : false;
    },
    // switchInput(event) {
    //   if (event.target == this.$refs.input_1 && this.num_1) {
    //     this.$refs.input_2.focus();
    //   } else if (event.target == this.$refs.input_2 && this.num_2) {
    //     this.$refs.input_3.focus();
    //   } else if (event.target == this.$refs.input_3 && this.num_3) {
    //     this.$refs.input_4.focus();
    //   } else if (event.target == this.$refs.input_4 && this.num_4) {
    //     this.$refs.input_5.focus();
    //   } else if (event.target == this.$refs.input_5 && this.num_5) {
    //     this.$refs.input_6.focus();
    //   }

    //   let el;
    //   if (event.target == this.$refs.input_6 && !this.num_6) {
    //     // this.$refs.input_5.focus();
    //     // this.num_5 = this.num_5;
    //     el = this.$refs.input_5;
    //   } else if (event.target == this.$refs.input_5 && !this.num_5) {
    //     // this.$refs.input_4.focus();
    //     // this.num_4 = this.num_4;
    //     el = this.$refs.input_4;
    //   } else if (event.target == this.$refs.input_4 && !this.num_4) {
    //     // this.$refs.input_3.focus();
    //     // this.num_3 = this.num_3;
    //     el = this.$refs.input_3;
    //   } else if (event.target == this.$refs.input_3 && !this.num_3) {
    //     // this.$refs.input_2.focus();
    //     // this.num_2 = this.num_2;
    //     el = this.$refs.input_2;
    //   } else if (event.target == this.$refs.input_2 && !this.num_2) {
    //     // this.$refs.input_1.focus();
    //     // this.num_1 = this.num_1;
    //     el = this.$refs.input_1;
    //   }
    //   if (
    //     event.inputType == "deleteContentBackward" &&
    //     event.target != this.$refs.input_1
    //   ) {
    //     this.invalidCode = false;
    //     el.focus();
    //     el.setSelectionRange(el.value.length, el.value.length);

    //     // el.focus();
    //     // if (typeof el.selectionStart == "number") {
    //     //   el.selectionStart = el.selectionEnd = el.value.length;
    //     // } else if (typeof el.createTextRange != "undefined") {
    //     //   var range = el.createTextRange();
    //     //   range.collapse(false);
    //     //   range.select();
    //     // }
    //   }
    // },
    onChange(value) {
      if (value.length < 6) {
        this.disableSubmit = true;
      } else if (value.length == 6) {
        this.disableSubmit = false;
      }
    },
    handleInput(e) {
      console.log("e", e);
    },
    onComplete(v) {
      this.verifyCode = v;
    },
    countDownTimer() {
      if (this.verifyCounter > 0) {
        setTimeout(() => {
          this.verifyCounter -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    startCount() {
      this.$refs.countdown.start();
    },
    resetCount() {
      this.counter_reload++;
      if (this.counter_reload >= 3) {
        console.log("max number of trys", this.counter_reload);
      } else {
        if (!this.visitor.username) {
          console.log("error");
        } else {
          this.sendVisitortoGetOneTimeCode(
            this.$route.query.add_visitor
              ? {
                  username: this.$route.query.email || this.$route.query.phone,
                  add_visitor: 1,
                  visit_url: this.$route.query.visit_url,
                  serverUrl: this.$route.query.serverUrl
                }
              : this.visitor
          );
          this.verifyCounter = 60;
          this.countDownTimer();
        }
      }
    },
    handelVerify() {
      // if (this.$refs.countdown.seconds == 0) {
      //   return (this.invalidCode = true);
      // }
      let data = {
        oneTimeCode: this.verifyCode,
        username: this.visitor.username,
      };
      this.verifyOneTimeCode(data)
        .then((res) => {
          let user = res.data;
          if (user.data.access_token) {
            localStorage.setItem("user", JSON.stringify(user));
          }
          store.commit("authfack/loginSuccess", user);
          store.commit("user/setUserData", user.data.user);
          store.commit("user/setCompanyName", user.data.user.company_name);
          store.dispatch("user/saveTmpPwdStatus", user.data.user.tmp_pwd);
          store.dispatch("user/saveUserEmail", user.data.user.email);
          store.dispatch("user/saveUserPhone", user.data.user.phone);
          store.dispatch("user/saveUserFirstName", user.data.user.first_name);
          store.dispatch("user/saveUserLastName", user.data.user.last_name);
          store.dispatch("user/saveUserTimeZone", user.data.user.timezone);
          store.dispatch("user/saveUserQr", user.data.user.passport_qr);
          this.$router.push({
            name: "dashboard",
            query: {
              ...this.$route.query,
            },
          });
        })
        .catch((err) => {
          this.invalidCode = true;
          console.log(err.response);
        });
    },
  },
  watch: {
    verifyCounter(counter) {
      if (counter == 0) {
        this.disableSubmit = true;
        this.verfyCode = null;
      }
    },
  },
  beforeMount() {
    if (!this.visitor.username) {
      console.log("error");
    } else {
      // if (!this.getOneTimeCodeSent || this.registredByEmail) {
      this.sendVisitortoGetOneTimeCode(
        this.$route.query.add_visitor
          ? {
              username: this.$route.query.email || this.$route.query.phone,
              add_visitor: 1,
              visit_url: this.$route.query.visit_url,
              serverUrl: this.$route.query.serverUrl
            }
          : this.visitor
      )
        .then(() => {
          this.loaded = true;
          this.countDownTimer();
        })
        .catch((e) => console.log("error", e));
      // }

      setTimeout(() => {
        if (
          !this.registredByEmail &&
          document.getElementsByTagName("input") &&
          document.getElementsByTagName("input").length > 0
        )
          for (
            let i = 0;
            i < document.getElementsByTagName("input").length;
            i++
          ) {
            document.getElementsByTagName("input")[i].addEventListener("keyup", (e) => {
                if (e.keyCode == 110 || e.keyCode == 46 || e.keyCode == 8) {
                  this.invalidCode = false;
                }
              });
          }
      }, 2000);
    }
    this.loaded = true;
  },
};
</script>
<style lang="scss" scoped>
.verification-code-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}
.wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: auto;
  justify-content: center;
  .page {
    display: flex;
    flex-direction: column;
    border-radius: 26px;
    margin-top: 114px;
    margin-bottom: 114px;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    // height: 645px;
    width: 491px;
    background-color: #ffffff;
    .header {
      .logo {
        display: block;
        width: 86px;
        height: 22px;
        margin: 49px auto 20px auto;
      }
      .header-msgs {
        .main-title {
          font-family: SF Pro Display;
          font-size: 20px;
          line-height: 24px;
          font-weight: 700;
          text-align: center;
          color: #000000;
          margin-bottom: 45px;
        }
        .sub-title {
          font-family: "Lato";
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #000000;
          margin-bottom: 44px;
        }
        .phone-main-title {
          font-family: "Lato";
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 19px;
          text-align: center;
          margin-bottom: 63px;
          color: rgba(0, 0, 0, 0.28);
        }
        .phone-sub-title {
          font-weight: 500;
          font-size: 16px;
          line-height: 30px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #000000;
          margin-bottom: 0px !important;
        }
        .six-digits-msg {
          font-weight: 400;
          font-size: 16px;
          line-height: 27px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #666666;
          margin-bottom: 27px;
        }
      }
    }
    .main-content2 {
      margin-bottom: 0;
      .card {
        width: 386px;
        height: 258px;
        margin: auto;
        background: #f2f2f2;
        border-radius: 17px;
        display: flex;
        align-items: center;

        .phone-card-title {
          font-weight: 400;
          font-size: 16px;
          line-height: 27px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #666666;
          margin-top: 20px;
          margin-bottom: 4px;
        }
        .phone-number {
          font-weight: 700;
          font-size: 16px;
          line-height: 27px;
          text-align: center;
          letter-spacing: 0.25px;
          color: #103f5e;
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.25px;
          text-align: center;
          color: rgba(16, 63, 94, 1);
          margin-bottom: 24px;
        }
      }
    }
  }
}

.six-inputs {
  width: 324px;
  height: 50px;
  margin: 0 auto 23px;
  display: flex;
  justify-content: space-between;
  span {
    width: 44px;
    height: 49px;
    border-radius: 4px;
    border: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    background-color: rgba(255, 255, 255, 1);
    input {
      width: 30px;
      height: 37px;
      background: transparent;
      border: none !important;
      font-weight: 700;
      font-size: 45px;
      line-height: 27px;
      text-align: center;
      letter-spacing: 0.25px;
      color: #103f5e;
      padding-top: 5px;
      // opacity: 0.3
    }
    .line {
      background: #c7c7c7;
      opacity: 0.3;
      width: 18px;
      height: 3px;
      position: absolute;
      top: 33px;
    }
  }
}
.six-inputs span input:focus {
  border: none;
  outline: none;
}
.six-inputs {
  margin-bottom: 25px;
}
.invaled-code {
  color: rgba(244, 106, 106, 1) !important;
}
.invaled-code-msg {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.25px;
  text-align: center;
  color: rgba(244, 106, 106, 1);
  margin-top: 15px;
  margin-bottom: 15px;
}
.time-counter {
  font-weight: 400;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #666666;
  margin-bottom: 4px;
}
.resend-btn {
  border: none;
  font-weight: 700;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #103f5e;

  margin-bottom: 41px;
  &:disabled {
    color: #96abb8;
    font-weight: 700;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.25px;
    cursor: not-allowed !important;
  }
}
.resend-btn:hover:enabled {
  color: #73a1be;
}
.main-btn {
  background: #103f5e;
  display: block;
  width: 386px;
  height: 44px;
  margin: 38px auto 59px auto;
  border-radius: 22px;
  font-weight: 700;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.25px;
  text-transform: uppercase;

  color: rgba(255, 255, 255, 0.87);
  border: none;
}
.dimmed-btn {
  background-color: #96abb8;
}
.card2-email {
  width: 386px;
  height: 238px;
  margin: auto;
  margin-bottom: 53px;
  background: #f2f2f2;
  border-radius: 17px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .mail-icon {
    height: 33px;
    width: 100%;
    margin: 53px auto 25px auto;
  }
  .card-title {
    font-family: "lato";
    font-style: normal;
    font-weight: 900;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #103f5e;
    margin: 0 auto 15px auto;
  }
  .card-msg {
    font-family: "Lato";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.25px;
    width: 321px;
    color: #666666;
    text-align: center;
    margin: 0 auto 32px auto;
  }
}
@media (max-width: 992px) {
  .wrapper {
    margin: auto;
    .page {
      width: 390px;
      // height: 100%;
      border-radius: 0px;
      margin-top: 0px;
      margin-bottom: 0px;
      .header {
        .logo {
          display: block;
          width: 116px;
          height: 22px;
          margin: 73px auto 22px auto;
          img{
            width: 116px;
          height: 22px;
          }
        }
        .header-msgs {
          .phone-main-title {
            font-family: "Lato";
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            line-height: 17px;
            /* identical to box height */

            text-align: center;

            color: rgba(0, 0, 0, 0.28);
            margin-bottom: 35px;
          }
          .sub-title {
            font-family: "Lato";
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            letter-spacing: 0.25px;
            color: #000000;
            margin-bottom: 114px;
          }

          .phone-sub-title {
            font-family: "Lato";
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 30px;

            text-align: center;
            letter-spacing: 0.25px;

            color: #000000;
          }
          .six-digits-msg {
            font-family: "Lato";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 27px;

            text-align: center;
            letter-spacing: 0.25px;
            margin-bottom: 54px;

            color: #666666;
          }
        }
      }
      .main-content2 {
        margin-bottom: 297px;
        .card {
          width: 316px;
          .six-inputs {
            width: 272px;
            height: 49px;
            margin: 0 auto 23px;
            display: flex;
            justify-content: space-between;
            span {
              width: 37px;
              height: 49px;
              border-radius: 4px;
              border: none;
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              position: relative;
              background-color: rgba(255, 255, 255, 1);
              input {
                width: 30px;
                height: 37px;
                background: transparent;
                border: none !important;
                font-weight: 700;
                font-size: 45px;
                line-height: 27px;
                text-align: center;
                letter-spacing: 0.25px;
                color: #103f5e;
                padding-top: 5px;
                // opacity: 0.3
              }
              .line {
                background: #c7c7c7;
                opacity: 0.3;
                width: 18px;
                height: 3px;
                position: absolute;
                top: 33px;
              }
            }
          }
          .six-inputs span input:focus {
            border: none;
            outline: none;
          }
          .six-inputs {
            margin-bottom: 25px;
          }
          .mail-icon {
            margin: 53px auto 25px;
          }
          .card-title {
            font-size: 16px;
            margin-bottom: 15px;
          }
          .card-msg {
            width: 321px;
            color: rgba(102, 102, 102, 1);
            margin: 0 auto 32px;
          }
          .phone-card-title {
            font-family: "Lato";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 27px;
            /* identical to box height, or 193% */

            text-align: center;
            letter-spacing: 0.25px;
            margin: 15px auto 4px auto;
            color: #666666;
          }
          .phone-number {
            margin-bottom: 21px;
            font-family: "Lato";
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            line-height: 27px;
            /* identical to box height, or 193% */

            text-align: center;
            letter-spacing: 0.25px;

            /* Main Button */

            color: #103f5e;
          }
        }
      }
    }
  }
  .card2-email {
    width: 316px !important;
    height: 238px;
    background: #f2f2f2;
    border-radius: 17px !important;
    .mail-icon {
      width: 47px;
      height: 33px;
      width: 100%;
      margin: 39px auto 24px auto !important;
    }
    .card2-email .card-title {
      font-family: "Nexa";
      font-style: normal;
      font-weight: 900;
      font-size: 18px;
      line-height: 22px;
      text-align: center;
      color: #103f5e;
      margin: 0 auto 19px auto;
    }
    p.card-msg {
      font-family: "Lato";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;

      text-align: center;
      letter-spacing: 0.25px;
      width: 267px !important;
      color: #666666;
      margin: 0 auto 40px auto;
    }
  }
  .time-counter {
    font-size: 16px;
  }
  .resend-btn {
    font-size: 16px;
    margin-bottom: 24px;
  }
  .main-btn {
    font-size: 16px;
    height: 37px;
    width: 309px;

    border-radius: 18.5px;
    margin: 41px auto -47px auto;
    span {
      font-family: "Lato";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */

      text-align: center;
      letter-spacing: 0.25px;
      text-transform: uppercase;

      color: rgba(255, 255, 255, 0.87);
    }
  }
}
</style>

<style lang="scss">
.react-code-input input {
  background: #ffffff !important;
  border-radius: 4px !important;
}
</style>